import { Product } from "../../utils/products";
import styles from "./ProductCard.module.css"

type ProductCardType = {
    product: Product
}

const ProductCard = (props: ProductCardType) => {

    const { product } = props;

    return <div className={styles.product_container} style={{ '--product_color': product.color } as React.CSSProperties}>
        <div className={styles.content}>
            <div className={styles.product_name} >
                {product.name}
            </div>
            <div className={styles.product_desc} >
                {product.description}
            </div>
        </div>
        <img src={product.coverPhoto} alt={product.name} className={styles.product_image}/>
    </div>
}

export default ProductCard;